

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from "../lib/Question";
    import {api} from "../Api";
    import store from "../store";
    import {AxiosResponse} from "axios";

    @Component({})
    export default class ExcelUploadQuestion extends Vue {
        @Prop()
        public question: Question;
        public uploaded: any = null;
        public dragging = false;
        public dragover = false;
        public filename = '';
        public fileSize = 0;
        public isValid = false;
        public maxSize = 50000000;
        public type = '';
        public progress = 0;
        public errorMessage = "";
        public loading = false;
        public templateFilePath = "";
        public successMessage = '';
        public acceptedTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
        public errors: any = {errors: [], message: ''};


        public loaded() {
            return this.filename !== '';
        }

        public selectFile(event: Event) {
            const input: HTMLInputElement = this.$refs.file as HTMLInputElement;
            const file = input.files.item(0);
            this.pickFile(file);
        }

        pickFile(file: File) {
            this.filename = file.name;
            const fileSize = (file.size / 1024); // converting bytes in kilobytes
            this.fileSize = parseFloat(fileSize.toFixed(2));
            this.validate(file);
            if (this.loaded() && this.isValid) {
                this.upload(file);
            }
        }

        public drop(event: DragEvent) {
            event.preventDefault();
            const files = event.dataTransfer.files;
            const file: File = files.item(0);
            this.pickFile(file);
        }

        public dropBoxOver() {
            this.dragover = true;
        }

        public dragend() {
            this.dragover = false;
        }

        public openFileInput() {
            this.$refs.file.click()
        }


        public validate(file) {
            if(!this.acceptedTypes.includes(file.type)){
                this.errorMessage = "Fichier incorrect, merci de charger un fichier xlsx";
                this.isValid = false;
            }else if (this.maxSize > 0 && file.size > this.maxSize) {
                this.errorMessage = "Le fichier depasse la limite de 50Mo";
                this.isValid = false
            }else{
                this.errorMessage = '';
                this.isValid = true;
            }

        }

        public upload(file: File) {
            const formData = new FormData();
            formData.append("excel", file, file.name);

            const onUploadProgress  = (progressEvent: ProgressEvent) => {
                if (progressEvent.lengthComputable) {
                    this.progress = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
                    if (this.progress > 98) {
                        this.loading = true;
                    }
                }
            };
            this.progress = 0;
            api.uploadExcel({responseGroupId: this.$store.state.currentResponseGroup.id, data: formData, onUploadProgress}).then((response: AxiosResponse) => {
                this.loading = false;
                if(response.data.status ==='failure'){
                    this.errors.message =  response.data.message;
                    if(response.data.hasOwnProperty('errors')){
                        this.errors.errors = [];
                        Object.keys(response.data.errors).forEach((index) => {
                            this.errors.errors.push( {cell: index, message: response.data.errors[index]});
                        });
                    }
                    this.successMessage = '';
                }else{
                    this.errors.errors = [];
                    this.errors.message =  '';
                    this.successMessage = "Le fichier a été pris en compte, " + response.data.count +  (response.data.count > 1 ? " véhicules trouvés!" : " véhicule trouvé!");
                    this.question.currentResponse.value = response.data.filename;
                    this.question.changedEvent.emit("");
                    this.question.validate();
                }
            })
        }

        public mounted() {
            window.document.addEventListener('dragover', (e) => {
                e.preventDefault();
                if (!this.dragover) {
                    this.dragging = true;
                }

            });
            if (this.question.currentResponse.value.length) {
                this.filename = this.question.currentResponse.value;
                this.isValid = true;
            }
            window.document.addEventListener('dragend', (e) => {
                e.preventDefault();
                this.dragging = false;
            });
            window.document.addEventListener('drop', (e) => {
                e.preventDefault();
            });
            this.templateFilePath = api.getCloudFilePath('excel_templates/', this.$store.state.currentBranch.excelTemplateFile);
        }

        public destroyed() {
            window.document.removeEventListener('dragover', (e) => {
                e.preventDefault();
                this.dragging = true;
            });
            window.document.removeEventListener('dragend', (e) => {
                e.preventDefault();
                this.dragging = false;
            });
            window.document.removeEventListener('drop', (e) => {
                e.preventDefault();
            });
        }
    }

